import { EnterprisePaths } from 'src/components/AppRoutes/Enterprise/EnterprisePathsDictionary';

const base = `${EnterprisePaths.reports}`;

export const ReportingPaths = {
  base,
  create: `${base}/create`,
  manage: base,
};
